import {Component, OnInit} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {Location} from '@angular/common';
import {UtilsService} from '../../core/services/utils/utils.service';
import {ApiService} from '../../core/http/api.service';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.css'],
    standalone: false
})
export class CreateUserComponent implements OnInit {

  payload = {
    firstName: '',
    lastName: '',
    email: '',
    profile: '',
    password: '',
    type: 'Bhakt',
    bio: '',
    twitterHandle: '',
    phone: '',
    username: '',
    canManageUnclaimedUserActivity: false
  };
  uploading = false;

  constructor(private dashboardService: DashboardService,
              private _location: Location,
              private utils: UtilsService,
              private api: ApiService) {
  }

  ngOnInit(): void {
  }

  uploadImage(event): void {
    this.uploading = true;
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.dashboardService.uploadImage({file: reader.result}).subscribe(
        res => {
          this.payload.profile = res.response.url;
          this.uploading = false;
        },
        err => {
          this.utils.resErr(err);
          this.uploading = false;
        });
    };
  }

  handleClickUpload(): void {
    const ele = document.getElementById('dp');
    if (!!ele) {
      ele.click();
    }
  }

  createProfile(): void {
    if (!this.payload.email.trim() && !this.payload.twitterHandle.trim()) {
      this.utils.toastError('Either Email or Twitter Handle is required.');
      return;
    }

    this.api.createProfile(this.payload).subscribe(() => {
      this.utils.toastSuccess('Profile created successfully!');
      this.utils.goBack();
    }, err => this.utils.resErr(err));
  }
}
